const _ = require('lodash');
const searchMapper = require('./atm/search-mapper');
const searchTypes = {
    PRODUCT: 'Products',
    SEARCH: 'Search',
    CATEGORY: 'Categories',
    EMPTYRESULTS: 'EmptyResults',
    STORE: 'Stores',
    TERMS: 'Terms'
};

class BwsSearchBarController {

    constructor($state, SearchService, $templateCache, MoveFocus, $filter, ContentOverlayService, $timeout, AtmService, $rootScope, jQuery, ShopLocatorService, SettingsService, $window) {
        this.$onInit = function() {
            this.ContentOverlayService = ContentOverlayService;
            this.$state = $state;
            this.searchPromptText = 'Find something you’ll love';
            this.searchTerm = '';
            this.autocompleteResults = [];
            this.searchService = SearchService;
            this.shopLocator = ShopLocatorService;
            this.lfSearchActive = false;
            this.debounceTime = 10;
            this.moveFocus = MoveFocus;
            this.isListOpen = false;
            this.hiphenate = $filter('hyphenate');
            this.$timeout = $timeout;
            this.atm = AtmService;
            this.resultsCache = [];
            this.searchVersion = 0;
            this.$window = $window;
            this.settingsService = SettingsService;

            // add the template to the autocomplete service
            this.template = 'search-item-template.html';
            $templateCache.put(this.template, require('./bws-search-bar-item-template.html'));

            // close the predictive search if any navigation statechange
            $rootScope.$on('$stateChangeStart', () => {
                this.setListOpen(false);
                this.setAIBoxVisibility(false);
            });

            // close the predictive search if click on the header
            jQuery('html').on('click', '.js-header-container', () => {
                this.setListOpen(false);
            });

            this.settingsService.getSettingValue('Search', 'SearchPromptText').then(setting => {
                this.searchPromptText = setting || 'Find something you’ll love';
            });
        };
    }

    updateOverlay() {
        if (this.autocompleteResults.length > 0 && this.isListOpen) {
            this.ContentOverlayService.open(this.closeSearch.bind(this));
        } else {
            this.ContentOverlayService.close();
        }
    }

    stripHtml(value) {
        return value.replace(/<(?:.|\n)*?>/gm, '');
    }

    navigateSearchPage(searchParam) {
        this.$state.go('shop.search', { searchTerm: this.hiphenate(searchParam) }, { inherit: false });
    }

    onSelect(haskKey) {
        this.searchVersion = 0;
        if (haskKey) {
            let type, item;

            // we had to pass the haskey because we want to keep autocomplete as generic as possible
            // and we can't use the selected object because of the a11y implementation on the autocomplete input
            _.each(this.autocompleteResults, (category) => {
                _.each(category.Suggestions, (suggestion) => {
                    if (suggestion.$$hashKey === haskKey) {
                        type = category.Type;
                        item = suggestion;
                        return;
                    }
                });
            });

            const atmData = {
                area: 'header',
                keyword: this.searchTerm,
                store: {},
                category: {},
                product: {},
                searchCategory: '',
                eventId: this.eventId
            };

            switch (type) {
                case searchTypes.PRODUCT:
                    atmData.searchCount = 'redirect';
                    atmData.searchType = 'product';
                    atmData.product = item;
                    this.atm.push(atmData, searchMapper);
                    this.searchTerm = '';
                    this.$state.go('shop.productdetails', { productId: item.ParentStockcode, productName: this.hiphenate(item.BwsProductUrl) });
                    break;
                case searchTypes.SEARCH:
                    this.searchTerm = '';
                    this.navigateSearchPage(item.Title);
                    break;
                case searchTypes.STORE:
                    atmData.searchCount = 'redirect';
                    atmData.searchType = 'store';
                    atmData.store = item;
                    this.atm.push(atmData, searchMapper);
                    this.searchTerm = '';
                    this.redirectStorePage(item);
                    break;
                case searchTypes.CATEGORY:
                    atmData.searchCount = 'redirect';
                    atmData.searchType = 'category';
                    atmData.category = item;
                    this.atm.push(atmData, searchMapper);
                    this.searchTerm = '';
                    let url;
                    let stateObj;
                    if (item.Subcategory) {
                        url = 'shop.browse.department.subdepartment.category.subcategory';
                        stateObj = { department: this.hiphenate(item.Department), subdepartment: this.hiphenate(item.Subdepartment), category: this.hiphenate(item.Category), subcategory: this.hiphenate(item.Subcategory) };
                    } else if (item.Category) {
                        url = 'shop.browse.department.subdepartment.category';
                        stateObj = { department: this.hiphenate(item.Department), subdepartment: this.hiphenate(item.Subdepartment), category: this.hiphenate(item.Category) };
                    } else if (item.Subdepartment) {
                        url = 'shop.browse.department.subdepartment';
                        stateObj = { department: this.hiphenate(item.Department), subdepartment: this.hiphenate(item.Subdepartment) };
                    } else if (item.Department) {
                        url = 'shop.browse.department';
                        stateObj = { department: this.hiphenate(item.Department) };
                    }
                    this.$state.go(url, stateObj, { reload: 'shop.browse.department', inherit: false });

                    break;
                case searchTypes.TERMS:
                    this.$state.go('shop.search', { searchTerm: item.Term, multisearchItems: undefined });
                    break;
                default:
            }

            this.searchTerm = '';
        } else {
            if (this.searchTerm) {
                this.searchService.setSearchIconClicked();
                this.navigateSearchPage(this.searchTerm);
            }
        }
        this.setListOpen(false);
        this.searchService.setAIBoxActive();
    }

    populateAutocompleteList(fnCallback) {
        this.searchService.resetSearchIconClick();
        if (this.searchTerm.length > 1) {

            this.searchVersion++;
            const newSearchVersion = this.searchVersion;

            this.searchService.predictiveSearch(this.searchTerm.toLowerCase()).then((response) => {

                if (newSearchVersion !== this.searchVersion) {
                    if (_.isFunction(fnCallback)) {
                        fnCallback();
                    }

                    return;
                }

                const results = [];
                for (const key in response.data) {
                    // check also if property is not inherited from prototype
                    if (response.data.hasOwnProperty(key) && response.data[key] && response.data[key].Suggestions && response.data[key].Suggestions.length > 0) {
                        const newItem = response.data[key];
                        newItem.Type = key;

                        results.push(newItem);
                    }
                }

                const terms = _.find(results, { Type: 'Terms' });
                const cats = _.find(results, { Type: 'Categories' });

                //Remove duplicates from terms array
                if (terms && cats) {
                    _.remove(terms.Suggestions, term => {
                        return _.some(cats.Suggestions, cat => {
                            return cat.Name.toLowerCase() === term.Term.toLowerCase();
                        });
                    });

                }

                if (results.length > 0) {
                    // add the search params to the search list
                    results.push({ Type: searchTypes.SEARCH, Order: 0, Suggestions: [{ Title: this.searchTerm, Subtitle: 'Search for ' + this.searchTerm }] });
                }

                results.stripHtml = this.stripHtml;

                this.resultsCache = results;

                this.autocompleteResults = this.resultsCache;
                this.eventId = response.headers('x-eventid');
                this.setListOpen(this.resultsCache.length > 0);

                if (_.isFunction(fnCallback)) {
                    fnCallback();
                }
            });

        } else {
            this.setListOpen(false);

            if (_.isFunction(fnCallback)) {
                fnCallback();
            }
        }
    }

    onInputFocus() {
        this.setListOpen(true);
        this.setAIBoxVisibility(true);
    }

    onFocusLost() {
        this.setListOpen(false);
        this.setAIBoxVisibility(false);
    }

    closeSearch() {
        this.setListOpen(false);
        this.setAIBoxVisibility(false);
    }

    setListOpen(value) {
        this.$timeout(() => {
            this.autocompleteResults = value && this.searchTerm && this.searchTerm.length > 1 ? this.resultsCache : [];
            this.isListOpen = value;
            this.updateOverlay();
            this.searchService.setAutoSuggestTopPosition(value);
        });
    }

    redirectStorePage(store) {
        this.settingsService.getFrontendSetting('StorePages', 'StorePagesRedirect')
            .then((res) => {
                const storePagesRedirectSettings = JSON.parse(res[0].Value);
                if (storePagesRedirectSettings && storePagesRedirectSettings.EnableRedirect) {
                    const suburbInYextFormat = store.SuburbName.trim().replace(/\s+/g, '-');
                    let storePathUrl = `${storePagesRedirectSettings.RedirectBaseUrl}/${store.State}-${suburbInYextFormat}-${store.StoreId}`;
                    storePathUrl = storePathUrl.toLocaleLowerCase();
                    this.$window.location.assign(storePathUrl);
                } else {
                    this.$state.go('shop.locator.store', { store: this.shopLocator.generateUrlParamsForStoreInfos(store) });
                }
            });
    }

    setAIBoxVisibility(value) {
        this.searchService.setAIBoxVisibility(value);
    }
}

module.exports = function () {
    return {
        restrict: 'E',
        controllerAs: 'vm',
        controller: ['$state', 'SearchService', '$templateCache', 'MoveFocus', '$filter',
            'ContentOverlayService', '$timeout', 'AtmService', '$rootScope', 'jQuery', 'ShopLocatorService', 'SettingsService', '$window', BwsSearchBarController],
        bindToController: {
        },
        scope: {},
        template: require('./bws-search-bar-template.html')
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/bws-search-bar-directive.js
 **/